import React from 'react';

import Screen, {backButton, useRetryButton} from 'editor/screens/Screen';
import {COPY} from 'text/errors';

/**
 * A project on the row store that the listing GET is converting (DQ1), or that another request holds. `takingLonger` is the 300 s budget of the
 * poll spent, or the read that cannot wait: Retry and Back come.
 */
export default function BeingPrepared({takingLonger = false}) {
    const retry = useRetryButton();
    const copy = COPY.screens.beingPrepared;

    return <Screen title={copy.title} body={takingLonger ? [copy.body, copy.takingLonger] : [copy.body]} buttons={takingLonger ? [retry, backButton] : []}/>;
}
